/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
import React from 'react'
import {DiffViewer} from '../DiffView'
import {MessageRowProps} from '../../columns/Message'
import style from '../../style/index.css'
import intl from '../../utils/intl/intl'

export const SyncProfileDiffViewer = ({item}: {item: MessageRowProps['item']}) => {
  const {payload} = item
  const shouldShowDiff = item.area === 'syncProfile'

  return shouldShowDiff && payload ? (
    <DiffViewer
      before={payload.oldProfile}
      after={payload.newProfile}
      language="yaml"
      options={{folding: true}}
    />
  ) : (
    <div className={style['detailed-view-no-diff-container']}>
      <div className={style['detailed-view-no-diff-message']}>
        {intl.formatMessage('Diff is not available')}
      </div>
    </div>
  )
}
